export default __webpack_public_path__ + "static/media/postgresql.f0f3d0b9.svg";